module.exports = __webpack_public_path__ + "static/media/earth-two-rings.cba7db3c.svg";